import React from 'react';
import { Marker, OverlayView } from 'react-google-maps';
import './CustomMarker.scss';

class CustomMarker extends React.Component {
  constructor (props) {
    super(props);

    this.overlayRef = React.createRef();

    this.state = {
      isUseOverlay: false,
    };
    // delay a little bit before render overlay
    // for prevent bug of library for OverlayView
    setTimeout(() => {
      this.setState({ isUseOverlay: true });
    }, 1000);
  }

  getPixelPositionOffset = (width, height) => ({
    x: -(width / 2),
    y: -height,
  });

  render () {
    const { isUseOverlay } = this.state;
    const { zIndex, tips } = this.props;
    const { position, icon, rotation = 0, children } = this.props;
    if (Number.isNaN(position.lat) || Number.isNaN(position.lng)) {
      return null;
    }
    return isUseOverlay ? (
      <OverlayView
        position={position}
        mapPaneName={OverlayView.MARKER_LAYER}
        ref={this.overlayRef}
        getPixelPositionOffset={this.getPixelPositionOffset}
      >
        <div className='custom-marker-container'>
          <div
            className='now-marker'
            style={{
              transform: `rotate(${rotation}deg)`,
            }}
          >
            {children}
          </div>
          {tips && (
            <div className='custom-marker-tooltip'>
              {!!tips?.title && (
                <p className='title'>{tips?.title}</p>
              )}
              {!!tips?.desc && (
                <p className='desc'>{tips?.desc}</p>
              )}
              <div className='custom-marker-tooltip-arrow' />
            </div>
          )}
        </div>
      </OverlayView>
    ) : (
      <Marker position={position} zIndex={zIndex} icon={icon} />
    );
  }
}

export default CustomMarker;
